import { useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { AuthContext } from '../context/AuthContext';

export default function OAuth() {
  const { signIn } = useContext(AuthContext);
  const navigate = useNavigate();
  const handled = useRef(false);
  const urlParams = new URLSearchParams(window.location.search);
  const accessToken = urlParams.get('accessToken');
  const accessTokenExpiresIn = urlParams.get('accessTokenExpiresIn');
  const refreshToken = urlParams.get('refreshToken');
  const error = urlParams.get('err');

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    if (error) {
      navigate(`/login?err=${encodeURIComponent(error)}`, { replace: true });
      return;
    }

    if (!accessToken || !refreshToken) {
      navigate('/login', { replace: true });
      return;
    }

    signIn(accessToken, accessTokenExpiresIn, refreshToken);
  }, [accessToken, accessTokenExpiresIn, refreshToken, error, signIn, navigate]);

  return null;
}